var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApotea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 251.2",
    style: {
      enableBackground: "new 0 0 283.5 251.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F00000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "silver"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "white"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.1,110.6l-74.7-101c-3.6-5.2-9.5-8.3-15.8-8.3H29.9l22.6,39.4h125.1l48.6,62.1l-124.6-0.6 c-5.9,0-11.4,2.7-15.1,7.3L5.8,217.1C1.1,223,0.2,231.2,3.4,238c3.2,6.8,10.1,11.2,17.5,11.2h158.5c5.8,0,11.2-2.6,14.9-7.1 l82.9-107.5C282.8,127.8,283.2,117.9,278.1,110.6z M170.3,209.8H61.4l50.7-67.5h110.2L170.3,209.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.1,649.4l-74.7-101c-3.6-5.2-9.5-8.3-15.8-8.3H29.9l22.6,39.4h125.1l48.6,62.1l-124.6-0.6 c-5.9,0-11.4,2.7-15.1,7.3L5.8,755.9c-4.7,5.9-5.6,14.1-2.4,20.9c3.2,6.8,10.1,11.2,17.5,11.2h158.5c5.8,0,11.2-2.6,14.9-7.1 l82.9-107.5C282.8,666.6,283.2,656.7,278.1,649.4z M170.3,748.6H61.4l50.7-67.5h110.2L170.3,748.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "black"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278.1,380l-74.7-101c-3.6-5.2-9.5-8.3-15.8-8.3H29.9l22.6,39.4h125.1l48.6,62.1l-124.6-0.6c-5.9,0-11.4,2.7-15.1,7.3 L5.8,486.5c-4.7,5.9-5.6,14.1-2.4,20.9c3.2,6.8,10.1,11.2,17.5,11.2h158.5c5.8,0,11.2-2.6,14.9-7.1L277.2,404 C282.8,397.2,283.2,387.3,278.1,380z M170.3,479.2H61.4l50.7-67.5h110.2L170.3,479.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "red"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.1,110.6l-74.7-101c-3.6-5.2-9.5-8.3-15.8-8.3H29.9l22.6,39.4h125.1l48.6,62.1l-124.6-0.6 c-5.9,0-11.4,2.7-15.1,7.3L5.8,217.1C1.1,223,0.2,231.2,3.4,238c3.2,6.8,10.1,11.2,17.5,11.2h158.5c5.8,0,11.2-2.6,14.9-7.1 l82.9-107.5C282.8,127.8,283.2,117.9,278.1,110.6z M170.3,209.8H61.4l50.7-67.5h110.2L170.3,209.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApotea);
export default __webpack_public_path__ + "static/media/apotea.d8a63ba239de06600b766cd242bc12e7.svg";
export { ForwardRef as ReactComponent };